import React from "react";

/**
 * SVG-based teal score ring, matching the MeowMD app's Activity Score card.
 * `score` 0-100, ringed against a soft mint track.
 * Color threshold: >=80 teal, 60-79 gold, <60 red.
 */
export function ScoreRing({ score, size = 200, stroke = 14, label = "/100" }) {
    const s = Math.max(0, Math.min(100, Math.round(score ?? 0)));
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const dashOffset = c - (s / 100) * c;

    const color = s >= 80 ? "#2A8B8B" : s >= 60 ? "#D4A017" : "#D64545";

    return (
        <div
            className="relative inline-flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid="score-ring"
        >
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    fill="none"
                    stroke="#E8F1EF"
                    strokeWidth={stroke}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    fill="none"
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={c}
                    strokeDashoffset={dashOffset}
                    style={{ transition: "stroke-dashoffset 1.1s ease-out, stroke 0.3s ease" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span
                    className="font-display text-[3.25rem] font-medium leading-none text-meow-charcoal tabular-nums"
                    data-testid="score-ring-value"
                >
                    {s}
                </span>
                <span className="mt-1 text-sm font-medium text-meow-muted">{label}</span>
            </div>
        </div>
    );
}
